//constants for stepper count
export const uploadFilesStepIndex = 0;
export const addDetailsStepIndex = 1;
export const reviewAndSubmitStepIndex = 2;
export const reviewAndSubmitSuccessStepIndex = 3;
